module.exports = __webpack_public_path__ + "static/media/03_MLPS-1.5-C-12.0-1_1.7bd06cf9.png";